import Break from "components/common/Scheduler/SchedulerRenderers/components/blocks/images/break.svg?react";
import eventBuilderStyles from "domain/bryntum/eventBuilders.module.scss";
import React from "react";
import renderToString from "./renderToString";

export default function overlappingBreaksIconRenderer() {
  return renderToString(
    <span className={eventBuilderStyles.dragBreak}>
      <Break className={eventBuilderStyles.breakIcon} size="x2" />
    </span>,
  );
}
